import React, { Component } from 'react';

import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../actions/index';
import { handleRemoveMessage, initSupport } from './Support.services';
import {
  Title,
  Paper,
  TableFooter,
  IconButton,
  SupportModal,
  EmptyView,
  Table
} from '../../components';
import { styles } from './Support.styles';
import { SUPPORT_TABLE_HEAD } from '../../constants/table';
import { getDateFormat } from '../../utils/suitableDate';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/support.svg';
import { EMPTY_DESIGN_SUPPORT_TEXT, EMPTY_DESIGN_SUPPORT_TITLE } from '../../constants/dishopInfo';
import apiService from '@dishopsaas/dishop-backend-api-service'

class Support extends Component {
  state = {
    isLoading: true,
    supportItem: {},
    showSupportModal: false,
    supportData: [],
    clients: {}
  };

  async componentDidMount() {
    const clients = await apiService.usersGetAll() // TODO this HEAVY Api call exists in PushNotification AND Clients AND Support.View PERF
    this.setState({ clients });
    initSupport(this.props, this);
  }

  async componentWillReceiveProps(props) {
    const { support, shopId } = props;
    const { support: prevSupport, shopId: oldShopId } = this.props;
    const { clients } = this.state;
    if (
      !_.isEmpty(clients) &&
      (!_.isEqual(prevSupport, support) || !_.isEqual(oldShopId, shopId))
    ) {
      initSupport(props, this);
    }
  }

  createTableRow = data => {
    const { classes } = this.props;
    const { showSupportModal, supportItem } = this.state;

    return (
      <TableBody>
        {data ?
          data.map((e, i) => {
            const { firstName, complainTime, dateComplain, orderNumber, reason } = e;
            return (
              <TableRow
                key={i.toString()}
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ showSupportModal: true, supportItem: e })}
              >
                <TableCell align="center" className={classes.row}>
                  {orderNumber ? `#${orderNumber}` : '--'}
                </TableCell>
                <TableCell align="center" className={classes.row}>
                  {firstName || '--'}
                </TableCell>
                <TableCell align="center" className={classes.row}>
                  {reason || '--'}
                </TableCell>
                <TableCell align="center" className={classes.row}>
                  {`${getDateFormat(dateComplain)} à ${complainTime || ''}`}
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    label="Delete"
                    title="Supprimer le message"
                    className={classes.icon}
                    onClick={event => handleRemoveMessage(event, e, this)}
                  >
                    <DeleteOutlinedIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          }) : null}
        {showSupportModal && (
          <SupportModal
            isOpen={showSupportModal}
            supportItem={supportItem}
            closeModal={() => this.setState({ showSupportModal: false })}
          />
        )}
      </TableBody>
    );
  };

  render() {
    const { supportData } = this.state;
    const { classes } = this.props;
    return (
      <div className="px-4 pb-4">
        <Title title="Support" />
        {!_.size(supportData) > 0 ? (
          <EmptyView
            className={classes.svg}
            src={ImportedSVG}
            viewBox="0 0 64 64"
            isLoading={this.state.isLoading}
            title={EMPTY_DESIGN_SUPPORT_TITLE}
            text={EMPTY_DESIGN_SUPPORT_TEXT}
          />
        ) : (
          <>
            <Paper className={classes.root} scrollOption="auto">
              <Table
                headCells={SUPPORT_TABLE_HEAD}
                classes={classes}
                bodyrows={supportData}
                createTableRow={data => this.createTableRow(data)}
                order="desc"
                orderBy="dateComplain"
                withEmptyCell
              />
            </Paper>

            <TableFooter lengthOption={_.size(supportData)} />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ support, user, page }) => {
  const { shopId, clients } = user;

  return { support, shopId, page, clients };
};

Support.propTypes = {
  classes: PropTypes.element.isRequired
};
export default connect(mapStateToProps, actions)(withStyles(styles)(Support));
